import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureAdoptionMatrix = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
        No feature adoption data available
      </div>
    );
  }

  const getAdoptionColor = (rate) => {
    if (rate >= 70) return 'text-success';
    if (rate >= 40) return 'text-primary';
    if (rate >= 20) return 'text-warning';
    return 'text-error';
  };

  const getCorrelationBadge = (correlation) => {
    if (correlation >= 0.8) return { label: 'Very High', color: 'bg-success/20 text-success' };
    if (correlation >= 0.6) return { label: 'High', color: 'bg-primary/20 text-primary' };
    if (correlation >= 0.4) return { label: 'Medium', color: 'bg-warning/20 text-warning' };
    return { label: 'Low', color: 'bg-muted text-muted-foreground' };
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-3 text-muted-foreground font-medium">Feature</th>
            <th className="text-center py-3 px-3 text-muted-foreground font-medium">Users</th>
            <th className="text-center py-3 px-3 text-muted-foreground font-medium">Adoption Rate</th>
            <th className="text-center py-3 px-3 text-muted-foreground font-medium">Avg Usage/Week</th>
            <th className="text-center py-3 px-3 text-muted-foreground font-medium">Premium Correlation</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((feature, index) => {
            const correlationBadge = getCorrelationBadge(feature?.premiumCorrelation);
            return (
              <tr key={index} className="border-b border-border/50 hover:bg-muted/30 transition-smooth">
                <td className="py-3 px-3">
                  <div className="flex items-center gap-2">
                    <Icon name="CheckCircle2" size={16} className={getAdoptionColor(feature?.adoptionRate)} />
                    <span className="font-medium text-foreground">{feature?.feature}</span>
                  </div>
                </td>
                <td className="py-3 px-3 text-center text-muted-foreground">
                  {feature?.users?.toLocaleString()}
                </td>
                <td className="py-3 px-3 text-center">
                  <span className={`font-semibold ${getAdoptionColor(feature?.adoptionRate)}`}>
                    {feature?.adoptionRate}%
                  </span>
                </td>
                <td className="py-3 px-3 text-center text-foreground font-medium">
                  {feature?.avgUsagePerWeek}
                </td>
                <td className="py-3 px-3 text-center">
                  <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${correlationBadge?.color}`}>
                    {correlationBadge?.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Legend */}
      <div className="mt-4 flex flex-wrap items-center gap-4 text-xs">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-success"></div>
          <span className="text-muted-foreground">≥70% Adoption</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-primary"></div>
          <span className="text-muted-foreground">40-69% Adoption</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-warning"></div>
          <span className="text-muted-foreground">20-39% Adoption</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-error"></div>
          <span className="text-muted-foreground">&lt;20% Adoption</span>
        </div>
      </div>
    </div>
  );
};

export default FeatureAdoptionMatrix;